// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-19b5dff0a0ac60da.css";
if (chunkId === "7350") return "css/7350-c4fb6e03132e1a07.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1632": "6b3ff39c47ca4ec9","1659": "6eaf583619a0bd55","193": "dfc6006df535e744","2390": "7883655edc831929","2429": "a73d2fa285645c40","2717": "c5820b193c3b10f0","3651": "73e614c04106123e","6580": "a892af76eb78c2e8",}[chunkId] + ".css"
}